import { formatDisplayDateTime } from "@/utils/date-format";

export type RecipientListRow = {
  recipientPhone?: string | null;
  sentAt?: string | null;
  deliveredAt?: string | null;
  readAt?: string | null;
  errorMessage?: string | null;
};

/**
 * Compact "phone · latest event" line for the mobile recipient card list — picks the most
 * advanced delivery milestone reached (read > delivered > sent), falling back to the error
 * message when none was reached.
 */
export function describeRecipientListSecondaryText(row: RecipientListRow): string {
  const parts: string[] = [];

  const phone = String(row.recipientPhone ?? "").trim();
  if (phone) {
    parts.push(phone);
  }

  if (row.readAt) {
    parts.push(`Read ${formatDisplayDateTime(row.readAt)}`);
  } else if (row.deliveredAt) {
    parts.push(`Delivered ${formatDisplayDateTime(row.deliveredAt)}`);
  } else if (row.sentAt) {
    parts.push(`Sent ${formatDisplayDateTime(row.sentAt)}`);
  } else if (row.errorMessage) {
    parts.push(String(row.errorMessage).trim());
  }

  return parts.join(" · ");
}
